'use strict';

var SelectCarrierConfig = function SelectCarrierConfig($stateProvider) {
  $stateProvider.state('app.select-carrier', {
    url: '/workflow/select-carrier',
    params: {
      transitionData: null,
      nextState: 'app.default'
    },
    views: {
      '': {
        template: require('../templates/select-carrier.html'),
        controller: 'SelectCarrierController'
      }
    }
  });
};
SelectCarrierConfig.$inject = ['$stateProvider'];
module.exports = SelectCarrierConfig;